// 📁 frontend/src/components/ErrorBoundary.js
// Rete di sicurezza globale: intercetta qualunque errore non gestito durante il render
// e mostra un messaggio di recupero invece di lasciare la schermata bianca.
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Errore non gestito:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen gap-6 p-8 text-center bg-white">
          <div className="max-w-sm flex flex-col gap-4 items-center">
            <h1 className="text-xl font-semibold text-gray-800">Qualcosa è andato storto</h1>
            <p className="text-gray-600">
              Si è verificato un errore imprevisto. Ricarica l'app per continuare — i tuoi dati salvati non vengono persi.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              className="bg-primary text-white rounded-lg px-6 py-3 font-semibold shadow hover:bg-blue-800 transition"
            >
              Ricarica l'app
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
